/**
 * Search Page Observability Event Names
 *
 * These constants define the event names tracked for search page observability.
 * Used with NewRelic Browser APM for monitoring search load failure.
 */

/**
 * Event tracked when the search page load fails
 */
export const SEARCH_PAGE_LOAD_FAILURE = 'search_page_load_failure' as const;
